import {
  CustomizableOptionTypeEnum,
  CustomizableOptionInterface,
  CustomizableCheckBoxOption,
  CustomizableSelectableOption,
  CustomizableSelectOption,
  CustomizableSwatchOption,
  CustomizableRadioOption,
  CustomizableTextOption,
  CustomizableTextAreaOption,
  CustomizableSwatchTypeEnum,
  CustomizableSwatchInterface,
  CustomizableTextSwatch,
  CustomizableColorSwatch,
  CustomizableImageSwatch,
} from 'types/types';

export const isSelectable = (
  option: CustomizableOptionInterface
): option is CustomizableSelectableOption =>
  Array.isArray((option as CustomizableSelectableOption).values) &&
  !!(option as CustomizableSelectableOption).values.length;

export const isCheckBox = (
  option: CustomizableOptionInterface
): option is CustomizableCheckBoxOption =>
  option.type === CustomizableOptionTypeEnum.CheckBox;

export const isSelect = (
  option: CustomizableOptionInterface
): option is CustomizableSelectOption =>
  option.type === CustomizableOptionTypeEnum.Select;

export const isMultiSelect = (
  option: CustomizableOptionInterface
): option is CustomizableSelectOption =>
  (option as CustomizableSelectOption).type ===
  CustomizableOptionTypeEnum.MultiSelect;

export const isSwatch = (
  option: CustomizableOptionInterface
): option is CustomizableSwatchOption =>
  option.type === CustomizableOptionTypeEnum.Swatch;

export const isSwatchMultiSelect = (
  option: CustomizableOptionInterface
): option is CustomizableSwatchOption =>
  (option as CustomizableSwatchOption).type ===
  CustomizableOptionTypeEnum.SwatchMultiSelect;

export const isColorSwatch = (
  swatch: CustomizableSwatchInterface
): swatch is CustomizableColorSwatch =>
  swatch.type === CustomizableSwatchTypeEnum.Color;

export const isImageSwatch = (
  swatch: CustomizableSwatchInterface
): swatch is CustomizableImageSwatch =>
  swatch.type === CustomizableSwatchTypeEnum.Image;

export const isTextSwatch = (
  swatch: CustomizableSwatchInterface
): swatch is CustomizableTextSwatch =>
  swatch.type === CustomizableSwatchTypeEnum.Text;

export const isRadio = (
  option: CustomizableOptionInterface
): option is CustomizableRadioOption =>
  option.type === CustomizableOptionTypeEnum.Radio;

export const isText = (
  option: CustomizableOptionInterface
): option is CustomizableTextOption =>
  (option as CustomizableTextOption).type === CustomizableOptionTypeEnum.Text;

export const isTextArea = (
  option: CustomizableOptionInterface
): option is CustomizableTextAreaOption =>
  option.type === CustomizableOptionTypeEnum.TextArea;
